import { Flex, Text } from '@chakra-ui/react';
import { FilledCircleBadge } from '@aslanpay/portal-common-lib';

const RANK_COLORS = [
  'brand.darkPurple',
  'brand.purple',
  'brand.mediumPurple',
  'brand.lightGray1',
  'brand.lightGray1',
];

interface LeaderboardRowProps {
  rank: number;
  primary: string;
  secondary?: string;
  value: number;
}

function LeaderboardRow({ rank, primary, secondary = undefined, value }: LeaderboardRowProps) {
  const index = rank - 1;
  const badgeColor = RANK_COLORS[index] ?? 'brand.lightGray1';
  const badgeTextColor = index < 3 ? 'white' : 'brand.darkGray';
  return (
    <Flex justify="space-between" align="center" py="10px" gap="12px">
      <Flex align="center" gap="12px" flex="1" minW="0">
        <FilledCircleBadge number={rank} color={badgeColor} textColor={badgeTextColor} />
        <Flex flexDir="column" gap="2px" minW="0">
          <Text textStyle="smallSemiBold" color="brand.mutedPurple" noOfLines={1}>
            {primary}
          </Text>
          {secondary && (
            <Text textStyle="extraSmallMedium" color="brand.darkGray" noOfLines={1}>
              {secondary}
            </Text>
          )}
        </Flex>
      </Flex>
      <Text textStyle="h5SemiBold" color="brand.mutedPurple" flexShrink={0}>
        {value.toLocaleString()}
      </Text>
    </Flex>
  );
}

export default LeaderboardRow;
